import {FC} from 'react'

import {Text, TextFontWeight} from '@/components/common/content/Text'
import {Link} from '@/i18n'
import {theme} from '@/theme/theme'

type IpCaseDetailRowProps = {
  title: string
  description?: string
  linkHref?: string
}

export const IpCaseDetailRow: FC<React.PropsWithChildren<IpCaseDetailRowProps>> = ({
  title,
  description,
  linkHref,
  children,
}) => (
  <>
    <div className="row">
      <Text fontWeight={TextFontWeight.bold}>
        {`${title}: `}
        {children ? (
          children
        ) : (
          <Text
            element="span"
            fontWeight={TextFontWeight.regular}
            className={linkHref ? 'underline' : ''}
          >
            {linkHref ? (
              <Link href={linkHref} prefetch={false}>
                {description}
              </Link>
            ) : (
              description
            )}
          </Text>
        )}
      </Text>
    </div>

    <style jsx>{`
      .row + .row {
        margin-top: ${theme.spacing[2]};
      }
    `}</style>
  </>
)
